<template>
    <div>
        <div class="card card-body">
            <h3 class="mb-7">
                {{ creationRequestSucceeded ? __('store.store_created') : __('navigation.create_store') }}
            </h3>
            <div v-if="creationRequestSucceeded" class="flex-1">
                <a :href="$route('store.index.all')" class="mr-5">
                    <i class="fa fa-fw fa-long-arrow-alt-left"></i> {{ __('navigation.all_stores') }}
                </a>
                <a
                    class="btn btn-primary"
                    :href="$route('admin.stores.create')">
                    {{ __('actions.store.add_store') }}
                </a>
            </div>
            <div v-else>
                <create-store
                    :local-business-types="localBusinessTypes"
                    :language="language"
                    :countries="countries"
                    :form-submit="formSubmit"
                    is-admin
                />
            </div>
        </div>
    </div>
</template>

<script>
import StoreLayout from '@layouts/StoreLayout.vue'
import CreateStore from '@components/CreateStore.vue'

export default {
    components: {CreateStore},
    layout: StoreLayout,

    props: {
        localBusinessTypes: Array,
        language: Object,
        formSubmit: {
            type: Boolean,
            default: true,
        },
        countries: Object,
        frontendUrl: String,

        storeCreationRequestSucceeded: {
            type: Boolean,
        },
        storeName: {
            type: String,
        },
    },

    data() {
        return {
            creationRequestSucceeded: this.storeCreationRequestSucceeded,
            store: this.storeName,
        }
    },
}
</script>
